import React from 'react';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Autocomplete, Typography, Grid, TextField } from '@mui/material';

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#3a8589',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

const Filter = ({
  brand,
  price,
  searchValue,
  handleSearch,
  model,
  onModelChange,
  onPriceHandler,
  onBrandChange,
  brandName,
  modelName,
}) => {
  let uniqueModel = [...new Set(modelName.map((item) => item))];

  return (
    <div>
      <Grid
        container
        spacing={2}
        justify="center"
        alignItems="center"
        alignContent="center"
      >
        <Grid
          item
          md={3}
          lg={3}
          sm={6}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TextField
            value={searchValue}
            onChange={(e) => handleSearch(e)}
            required
            id="standard"
            // sx={{ width: matches ? 200 : 300 }}
            fullWidth
            defaultValue=""
            placeholder="Search"
            variant="standard"
          />
        </Grid>
        <Grid
          item
          md={3}
          lg={3}
          sm={6}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Autocomplete
            clearOnEscape
            id="flat-demo"
            value={brand}
            options={brandName}
            onChange={onBrandChange}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                fullwidth
                id="standard"
                placeholder="brand"
              />
            )}
          />
        </Grid>
        <Grid
          item
          md={3}
          lg={3}
          sm={6}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Autocomplete
            clearOnEscape
            id="flat-demo"
            options={uniqueModel}
            // sx={{ width: matches ? 200 : 300 }}
            onChange={onModelChange}
            value={model}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                fullWidth
                id="standard"
                placeholder="Model"
              />
            )}
          />
        </Grid>
        <Grid
          item
          md={3}
          lg={3}
          sm={6}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: '100%' }}>
            <div>
              <Typography
                variant="subtitle2"
                color="inherit"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                ${price[0]} <span> ${price[1]}</span>
              </Typography>
            </div>
            <AirbnbSlider
              min={0}
              max={100000}
              components={{ Thumb: AirbnbThumbComponent }}
              getAriaLabel={(index) =>
                index === 0 ? 'Minimum price' : 'Maximum price'
              }
              value={price}
              fullWidth
              onChange={onPriceHandler}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Filter;
